module.exports = __webpack_public_path__ + "img/solution-farmer-advantage2.44d92431.svg";